import React from 'react'

import { CountryFlag } from '@fourthwall/components'

import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { StatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'sales_by_country'

type SalesByCountryRow = {
  country: string
  income: { value: number; currency: string }
}

export const useSalesByCountryReportCard = (): StatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({ reportId })

  const data = createStatsData<SalesByCountryRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label: <CountryFlag countryCode={row.country} />,
      value: row.income.value,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'stats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Sales by country',
      tooltip: {
        title: 'Sales by country',
        description: 'Breakdown of sales grouped by the buyer’s country.',
      },
    },
  }
}
